import { render, staticRenderFns } from "./StepperItems.vue?vue&type=template&id=53236b6a&"
import script from "./StepperItems.vue?vue&type=script&lang=js&"
export * from "./StepperItems.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports